export class ObjectPool {
    constructor() {
        this._availableObjects = [];
    }
    get objectCount() {
        return this._availableObjects.length;
    }
    getObject() {
        if (this._availableObjects.length > 0) {
            return this._availableObjects.pop();
        }
        else {
            return null;
        }
    }
    returnObject(instance) {
        this._availableObjects.push(instance);
    }
}
//# sourceMappingURL=ObjectPool.js.map